document.addEventListener('DOMContentLoaded', () => {
  const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
  const slickElement = $('.ft-min-all-in-app .slick');

  const toggleActiveContent = id => {
    const content = document.querySelector(
      `.ft-min-all-in-app .item-content#${id}`
    );
    if (content) {
      content.classList.toggle('active');
    }
  };

  let imageSwitchInterval;

  slickElement.on('init', function (event, slick) {
    if (isDesktop) {
      document.querySelectorAll('.ft-min-all-in-app .pictures').forEach(el => {
        const animations = [];

        el.querySelectorAll('.pictures [id^="lottie-"]').forEach(animEl => {
          const path = animEl.dataset.lottieDesk;

          if (path) {
            animations.push(
              bodymovin.loadAnimation({
                container: animEl,
                path: path,
                renderer: 'svg',
                loop: true,
                autoplay: false
              })
            );
          }
        });

        el.addEventListener('mouseenter', () => {
          animations.forEach(anim => {
            anim.play();
          });
        });

        el.addEventListener('mouseleave', () => {
          animations.forEach(anim => {
            anim.stop();
          });
        });
      });
      document
        .querySelectorAll('.ft-min-all-in-app .pictures')
        .forEach(function (el) {
          const pictures = el.querySelectorAll('picture');
          pictures.forEach(picture => {
            picture.remove();
          });
        });
    } else {
      const fadeInSection = document.querySelector('.ft-min-all-in-app .items');

      const handleIntersection = entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.remove('tw-opacity-0', 'tw-translate-y-4');
            entry.target.classList.add('tw-opacity-100', 'tw-translate-y-0');

            toggleActiveContent(
              document.querySelector('.ft-min-all-in-app .item.slick-current')
                .dataset.blockId
            );

            observer.unobserve(fadeInSection);
          }
        });
      };

      const observer = new IntersectionObserver(handleIntersection, {
        threshold: 0.5
      });

      observer.observe(fadeInSection);
    }
  });

  slickElement.not('.slick-initialized').slick({
    infinite: false,
    dots: false,
    arrows: true,
    appendArrows: $('.ft-min-all-in-app .custom-slick-nav-container'),
    slidesToShow: 2.3,
    variableWidth: true,
    draggable: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerMode: true,
          centerPadding: '30px',
          slidesToShow: 1,
          dots: true,
          infinite: true,
          arrows: false,
          variableWidth: true,
          appendDots: $('.ft-min-all-in-app .custom-slick-nav-container'),
          draggable: true
        }
      }
    ]
  });

  if (!isDesktop) {
    let divPaginationAnimate = document.createElement('div');
    divPaginationAnimate.classList.add('square_pagination');
    const dotsConrainer = document.querySelector(
      '.ft-min-all-in-app .slick-dots'
    );

    dotsConrainer.append(divPaginationAnimate);

    let swipeInterval;

    slickElement
      .on('beforeChange', function (event, slick, currentSlide) {
        clearInterval(imageSwitchInterval);
        swipeInterval = setInterval(updateSquarePosition, 16);

        const currentSlideEl = slick.$slides.get(currentSlide);
        if (currentSlideEl) {
          const blockId = currentSlideEl.dataset.blockId;
          toggleActiveContent(blockId);
        }
      })
      .on('afterChange', function (event, slick, currentSlide) {
        clearInterval(swipeInterval);
        updateSquarePosition();

        const currentSlideEl = slick.$slides.get(currentSlide);
        if (currentSlideEl) {
          const blockId = currentSlideEl.dataset.blockId;
          toggleActiveContent(blockId);
          setTimeout(() => {
            if (currentSlideEl) {
              startImageSwitcher(currentSlideEl);
            }
          }, 3000);
        }
      });

    document.addEventListener('click', updateSquarePosition);

    let lastOffsetLeft = 0;

    function updateSquarePosition() {
      const activeDot = dotsConrainer.querySelector(
        '.ft-min-all-in-app .slick-dots .slick-active'
      );
      const divPaginationAnimate = dotsConrainer.querySelector(
        '.ft-min-all-in-app .slick-dots .square_pagination'
      );

      if (activeDot && divPaginationAnimate) {
        const activeRect = activeDot.getBoundingClientRect();
        const containerRect = dotsConrainer.getBoundingClientRect();
        const offsetLeft = activeRect.left - containerRect.left;

        const jumpDistance = Math.abs(offsetLeft - lastOffsetLeft);

        if (jumpDistance > 100) {
          divPaginationAnimate.style.transition = 'none';

          const isNearRight =
            offsetLeft > containerRect.width - divPaginationAnimate.offsetWidth;

          const isNearLeft = offsetLeft < 0;

          if (isNearRight) {
            divPaginationAnimate.style.right = '0';
            divPaginationAnimate.style.left = 'initial';
          } else if (isNearLeft) {
            divPaginationAnimate.style.left = '0';
            divPaginationAnimate.style.right = 'initial';
          } else {
            divPaginationAnimate.style.left = `${offsetLeft}px`;
            divPaginationAnimate.style.right = 'initial';
          }

          void divPaginationAnimate.offsetWidth;

          divPaginationAnimate.style.transition = '';
        } else {
          divPaginationAnimate.style.left = `${offsetLeft}px`;
          divPaginationAnimate.style.right = 'initial';
        }

        lastOffsetLeft = offsetLeft;
      }
    }

    function imageClassSwitcher(slideElement) {
      const images = slideElement.querySelectorAll('img');
      if (images.length === 0 || images.length == 1) return;

      let currentIndex = Array.from(images).findIndex(img =>
        img.classList.contains('active')
      );

      if (currentIndex !== -1) {
        images[currentIndex].classList.remove('active');
      }

      const nextIndex = (currentIndex + 1) % images.length;
      images[nextIndex].classList.add('active');
    }

    function startImageSwitcher(slideElement) {
      clearInterval(imageSwitchInterval);
      imageClassSwitcher(slideElement);

      imageSwitchInterval = setInterval(() => {
        imageClassSwitcher(slideElement);
      }, 3000);
    }

    setTimeout(() => {
      startImageSwitcher(
        document.querySelector('.ft-min-all-in-app .item.slick-current')
      );
    }, 3000);
  }
});
